// src/redux/slicers/siteSettingsSlicer.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";
import {
  applySiteSettings,
  cacheSiteSettings,
} from "../../../utils/applySiteSettings";

// ----------- Async Thunk (GET settings) -----------
export const fetchSiteSettings = createAsyncThunk(
  "siteSettings/fetch",
  async (_, thunkAPI) => {
    try {
      const response = await api.get("/dashboard/general-settings");
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ----------- Async Thunk (UPDATE settings) -----------
export const updateSiteSettings = createAsyncThunk(
  "siteSettings/update",
  async (data, thunkAPI) => {
    try {
      const response = await api.post("/dashboard/general-settings", data);
      await thunkAPI.dispatch(fetchSiteSettings());
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ----------- Slice ----------- 
const siteSettingsSlicer = createSlice({
  name: "siteSettings",
  initialState: {
    data: [],
    loading: false,
    error: null,
    successMessage: "",
  },
  reducers: {
    clearSiteSettingsState: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSiteSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSiteSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        cacheSiteSettings(action.payload);
        applySiteSettings(action.payload);
      })
      .addCase(fetchSiteSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateSiteSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSiteSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(updateSiteSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSiteSettingsState } = siteSettingsSlicer.actions;
export default siteSettingsSlicer.reducer;
